/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

/**
 * @namespace Phaser.DOM
 */

module.exports = {

    AddToDOM: require('./AddToDOM'),
    DOMContentLoaded: require('./DOMContentLoaded'),
    ParseXML: require('./ParseXML'),
    RemoveFromDOM: require('./RemoveFromDOM'),
    RequestAnimationFrame: require('./RequestAnimationFrame')

};



//////////////////
// WEBPACK FOOTER
// ./dom/index.js
// module id = 521
// module chunks = 0